export default __webpack_public_path__ + "static/media/demoimg.24cbf779.png";